import { render } from "./flinks.vue?vue&type=template&id=5bc9a806&ts=true"
import script from "./flinks.vue?vue&type=script&lang=ts"
export * from "./flinks.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__